import React from 'react';
import { clsx } from 'clsx';

export interface GradientHeroProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

export const GradientHero: React.FC<GradientHeroProps> = ({
  title,
  description,
  children,
  className,
}) => (
  <section
    className={clsx(
      'py-20 px-4 bg-gradient-to-br from-brand-primary via-brand-primary-dark to-brand-accent text-white',
      className,
    )}
  >
    <div className="max-w-4xl mx-auto text-center">
      <h1 className="text-5xl font-bold mb-6">{title}</h1>
      {description && (
        <p className="text-xl text-white/90 max-w-2xl mx-auto">{description}</p>
      )}
      {children}
    </div>
  </section>
);
